import { useTranslation } from 'react-i18next'

export type PriceSummaryTemplate =
  | 'total'
  | 'current'
  | 'discounts'
  | 'configuration'

type PriceSummaryInstallmentVariant = 'monthly'

export type PriceSummaryInstallment = PriceSummaryInstallmentVariant | null

export interface PriceSummaryProps {
  price?: number
  priceBefore?: number
  template?: PriceSummaryTemplate
  textTop?: string
  textBottom?: string
  installment?: PriceSummaryInstallment
  className?: string
  isLoading?: boolean
}

export const useTextTemplate = (template: PriceSummaryTemplate | undefined) => {
  const { t } = useTranslation(['summary'])

  if (!template) {
    return {
      top: '',
      bottom: '',
    }
  }

  const text = {
    total: {
      top: t('summary:price.total'),
      bottom: '',
    },
    current: {
      top: t('summary:price.current'),
      bottom: '',
    },
    discounts: {
      top: '',
      bottom: t('summary:price.discounts'),
    },
    configuration: {
      top: t('summary:price.configuration'),
      bottom: '',
    },
  } satisfies Record<PriceSummaryTemplate, { top: string; bottom: string }>

  return text[template]
}
